/**
 * Account Description Validation and Tooltip Enablement
 */

// UX-specified character count
const ACCT_DESC_CHAR_COUNT_LIMIT = 500;
const ACCT_DESC_CHAR_COUNT_TRUNCATE_LIMIT = 120;
const ACCT_DESC_CHAR_COUNT_TOOLTIP_LIMIT = 200;

// Check that the account description falls within the UX-specified character count
export const isAcctDescWithinCharLimit = (acctDesc) =>
  acctDesc.length <= ACCT_DESC_CHAR_COUNT_LIMIT;

// Check that the account description falls within the string truncation limit
export const isAcctDescWithinTruncateLimit = (acctDesc) =>
  acctDesc.length < ACCT_DESC_CHAR_COUNT_TRUNCATE_LIMIT;

// Check that the account description falls within the tooltip string limit (for maxWidth calculations)
export const isAcctDescWithinToolTipLimit = (acctDesc) =>
  acctDesc.length < ACCT_DESC_CHAR_COUNT_TOOLTIP_LIMIT;

// Check for disabling/enabling account description tooltip
export const isAcctDescToolTipDisabled = (acctDesc) =>
  isAcctDescWithinCharLimit(acctDesc) &&
  isAcctDescWithinTruncateLimit(acctDesc);

/**
 * Account Description Tooltip Max Width Calculation
 */

// calculate min and max width of account description tooltip
export const PIXELS_PER_REM =
  parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

export const getAcctDescTooltipCustomMaxWidth = (viewPortWidth) => {
  const viewportWidthDifferential = viewPortWidth / 10;

  if (viewPortWidth > 60) {
    return `calc(50% - ${viewportWidthDifferential}rem)`;
  }

  if (viewPortWidth <= 60 && viewPortWidth > 40) {
    return `calc(75% - ${viewportWidthDifferential}rem)`;
  }

  return `calc(100% - ${viewportWidthDifferential}rem)`;
};
